import React from 'react';
import { Box } from '@mui/material';
import ComingSoon from '../../Components/ComingSoon';

const AnnualReportsDashboard: React.FC = () => {
  return (
    <Box>
      <ComingSoon
        title="Annual Reports Dashboard"
        subtitle="Your Central Hub for Annual Reporting"
        description="Track and manage all your annual reporting requirements in one place. This dashboard will help you monitor outstanding items, view completed tasks, and quickly access all reporting functions."
      />
    </Box>
  );
};

export default AnnualReportsDashboard;
